
export default {
  name: 'BannerAdvert',

  props: {
    localAdvert: {
      type: Object,
      default: () => ({})
    },

    paddockId: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      getAdvertApi: new this.$ApiModel(),
      impressionApi: new this.$ApiModel(),
      clickApi: new this.$ApiModel()
    }
  },

  computed: {
    compIsLocalAdvert() {
      return !!this.localAdvert?.name
    },

    compAdvert() {
      return this.compIsLocalAdvert ? this.localAdvert : this.getAdvertApi.response.data?.[0]
    },

    compIsImageOnly() {
      return !!this.compAdvert?.featuredImage?.publicUrl && !this.compAdvert?.title && !this.compAdvert?.body
    },

    compIsReady() {
      return (
        !!this.compAdvert?.title ||
        !!this.compAdvert?.body ||
        !!this.compAdvert?.featuredImage?.publicUrl ||
        !!this.compAdvert?.buttonLink
      )
    }
  },

  created() {
    this.fetchAdvert()
  },

  methods: {
    async fetchAdvert() {
      if (this.advert?.title || !this.paddockId) {
        return false
      }

      await this.$api.advert(this.getAdvertApi).getAvailable({ paddockId: this.paddockId })

      this.logImpression()
    },

    async logImpression() {
      if (!this.compAdvert?.id || this.compIsLocalAdvert) {
        return false
      }

      await this.$api.advert(this.impressionApi).logImpression(this.compAdvert.id)
    },

    onClick() {
      this.logClick()

      if (this.compAdvert?.buttonLink) {
        this.$openWindow(this.compAdvert.buttonLink)
      }
    },

    async logClick() {
      if (!this.compAdvert?.id || this.compIsLocalAdvert) {
        return false
      }

      await this.$api.advert(this.clickApi).logClick(this.compAdvert.id)
    }
  }
}
